/**
 * Generated bundle index. Do not edit.
 */
export { MatFormFieldModule, MatError, MatFormField, MatFormFieldControl, getMatFormFieldPlaceholderConflictError, getMatFormFieldDuplicatedHintError, getMatFormFieldMissingControlError, MatHint, MatPlaceholder, MatPrefix, MatSuffix } from './public-api';
//# sourceMappingURL=index.js.map